import React, { memo,useState,useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterCpn from '../../../components/Footer/Footer-cpn';
import MenuCpn from '../../../components/Menu/Menu-cpn'
import { Wrap } from './index';

export default memo(function Theme() {

  useEffect(() => {
    document.getElementById('root').scrollTop = 0;
    document.title = '投资者服务';
  }, []);

  const [items] = useState([
    {
      id:1,
      imgUrl:require('../../../assets/img/theme_03.png').default,
      name:'公司战略'
    },
    {
      id:2,
      imgUrl:require('../../../assets/img/theme_05.png').default,
      name:'公司业绩'
    },
    {
      id:3,
      imgUrl:require('../../../assets/img/theme_06.png').default,
      name:'研发创新'
    },
    {
      id:4,
      imgUrl:require('../../../assets/img/theme_07.png').default,
      name:"连云港产业园"
    },
    {
      id:5,
      imgUrl:require('../../../assets/img/theme_08.png').default,
      name:'锂电池与正极材料'
    },
    {
      id:6,
      imgUrl:require('../../../assets/img/theme_09.png').default,
      name:'高性能材料'
    },
    {
      id:7,
      imgUrl:require('../../../assets/img/theme_10.png').default,
      name:'聚合物添加剂'
    },
    {
      id:8,
      imgUrl:require('../../../assets/img/theme_11.png').default,
      name:'轻量化材料'
    }
  ])
  return (
    <>
      <MenuCpn></MenuCpn>
      <Wrap>
        <section>
          <h3>投资者常见问题</h3>
          <div className="box">
            {
              items.map(item=>{
                return (<Link className="item" to={'/FAQ/'+item.id} key={item.name}>
                  <img src={item.imgUrl} alt={item.id} style={{objectFit: 'fill'}}/>
                  <div>
                    <h5>{item.name}</h5>
                    <img src={require('../../../assets/img/arrow_bai.png').default} alt=""/>
                  </div>
                </Link>)
              })
            }
          </div>
        </section>
       
        <FooterCpn/>
      </Wrap>
      
     
      
    </>
  )
})
